import "../src/styles/globals.scss";
import React from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "reportWebVitals.js";
import MainRoutes from "routes/main/index";
import { CommonProvider } from "contexts/CommonContext";
const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <CommonProvider>
      <MainRoutes />
    </CommonProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
